<template functional>
  <div v-translate="{refereeName: props.refereeName, index: props.index}">
    %{ refereeName }'s application %{ index }
  </div>
</template>

<script>
export default {
  props: {
    refereeName: {type: String},
    index: {type: Number}
  }
};
</script>
